module.exports = __webpack_public_path__ + "img/ana_lopes.a988fe62.jpeg";